import { RawConfiguration } from './RawConfiguration'

export const loadConfiguration = (configUrl: string): Promise<RawConfiguration> =>
  fetch(configUrl).then((response) => response.json())
